module.exports = __webpack_public_path__ + "static/media/edit.71f9bba2.svg";